import Tooltip from './src/index'

export default Tooltip
